import React from 'react';

const Number = ({number}) => {
        
    return (
        <li>{number}</li>
    )
}

export default Number;